import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

import { BaseService } from "./base.service";
import { Adjudication } from "../models/adjudication.model";

@Injectable()
export class AdjudicationService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getAdjudication(patientId: string): Promise<Adjudication> {
    return this.get("adjudication/" + patientId);
  }

  async createAdjudication(
    adjudication: Adjudication,
    visitId: string,
    studyId: string
  ): Promise<null> {
    return this.post(
      "adjudication/" + visitId + "/" + encodeURIComponent(studyId),
      adjudication
    );
  }

  async updateAdjudication(
    adjudicationId: number,
    adjudication: Adjudication,
    visitId: string,
    studyId: string
  ): Promise<null> {
    return this.post(
      "adjudication/" +
        adjudicationId +
        "/" +
        visitId +
        "/" +
        encodeURIComponent(studyId),
      adjudication
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/adjudication.service.ts